import React, { ReactElement, SyntheticEvent } from 'react';
import { CSSObject } from 'styled-components';
import { SpaceProps, LayoutProps, FlexboxProps } from 'styled-system';

import { ReactSelect } from '../reactSelect';
import { FormGroup } from '../index';

import { FormLabel, StyledFormFeedback } from 'ui/components';

type ssProps = SpaceProps & LayoutProps & FlexboxProps;

type SelectProps = ssProps & {
  name?: string;
  label: string;
  value?: number | string | any;
  inputValue?: string;
  onTextChange?: (text: string) => void;
  type?: 'email' | 'number' | 'password' | 'search' | 'text' | 'tel' | 'url';
  placeholder?: string | undefined;
  disabled?: boolean;
  validation?: 'error' | 'success' | 'warning';
  feedback?: string;
  required?: boolean;
  options?: Array<{ value: number | string; label: any }> | undefined;
  register?: ({ required }: { required?: boolean }) => RefReturn;
  onChange?: (e: SyntheticEvent<HTMLSelectElement>, action?: any) => void;
  onBlur?: () => void;
  noSelectOption?: boolean;
  style?: CSSObject;
  isSearchable?: boolean;
  menuPlacement?: 'auto' | 'bottom' | 'top';
  onInputChange?: (inputValue: string, action?: any) => void;
  isLoading?: boolean;
  isClearable?: boolean;
  loadingMessage?: () => string;
  menuPortalTarget?: HTMLElement;
  menuShouldScrollIntoView?: boolean;
  noOptionsMessage?: () => string;
};

type item = string;

type RefReturn =
  | string
  | ((instance: HTMLSelectElement | null) => void)
  | React.RefObject<HTMLSelectElement>
  | null
  | undefined;

const FormReactSelect = ({
  name,
  label,
  inputValue,
  value,
  disabled,
  validation,
  feedback,
  required,
  options,
  onChange,
  onBlur,
  style,
  isSearchable = false,
  menuPlacement,
  onInputChange,
  isClearable,
  isLoading,
  loadingMessage,
  menuPortalTarget,
  menuShouldScrollIntoView,
  noOptionsMessage,
  ...ssProps
}: SelectProps): ReactElement => {
  const id = `toggle-${label ? label.replace(/ /g, '').toLowerCase() : null}`;

  return (
    <FormGroup style={style} {...ssProps}>
      {label ? (
        <FormLabel htmlFor={id} required={required}>
          {label}
        </FormLabel>
      ) : null}
      <ReactSelect
        options={options}
        inputValue={inputValue}
        name={name}
        value={value}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        isSearchable={isSearchable}
        classNamePrefix="pr-select"
        menuPlacement={menuPlacement}
        onInputChange={onInputChange}
        isClearable={isClearable}
        isLoading={isLoading}
        loadingMessage={loadingMessage}
        menuPortalTarget={menuPortalTarget}
        menuShouldScrollIntoView={menuShouldScrollIntoView}
        noOptionsMessage={noOptionsMessage}
      />
      {feedback ? (
        <StyledFormFeedback validation={validation}>
          {feedback}
        </StyledFormFeedback>
      ) : null}
    </FormGroup>
  );
};

export { FormReactSelect };
